/* Keep the original app/share nodes and listeners inside product-info. */
(() => {
  const script = document.currentScript;
  const actionsLabel = script?.dataset.jdActionsLabel || 'Product actions';
  const shareLabel = script?.dataset.jdShareLabel || 'Share this product';
  let scheduled = false;
  function placeActions() {
    scheduled = false;
    document.querySelectorAll('.product__info-container').forEach((info) => {
      const product = info.closest('.product');
      const media = product?.querySelector('.product__media-wrapper');
      if (!media?.querySelector('media-gallery')) return;
      const controls = [...info.children].filter((element) =>
        element.matches('.shopify-app-block[id*="wishlist_hero"],share-button'));
      if (!controls.length) return;
      let toolbar = media.querySelector(':scope > .jd-product-actions');
      if (!toolbar) {
        toolbar = document.createElement('div');
        toolbar.className = 'jd-product-actions';
        toolbar.setAttribute('role', 'group');
        toolbar.setAttribute('aria-label', actionsLabel);
        media.append(toolbar);
      }
      controls.sort((a, b) => Number(a.matches('share-button')) - Number(b.matches('share-button')));
      controls.forEach((control) => {
        if (control.matches('share-button')) {
          const button = control.querySelector('.share-button__button');
          if (button && !button.textContent.replace(/[\u200B-\u200F\uFEFF]/g, '').trim()) button.setAttribute('aria-label', shareLabel);
        }
        toolbar.append(control);
      });
    });
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(placeActions); }
  }
  function start() {
    placeActions();
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', schedule);
})();
